import { Injectable } from '@angular/core';

import { TaskMapper } from '../contracts/task-mapper.contract';
import { TaskDataMap, TaskResponse, TaskType } from '../models/task.interface';

function normalizePhone(phone: string | undefined): string {
  if (!phone) return '';
  return phone.startsWith('+') ? phone : `+${phone}`;
}

@Injectable()
export class ManualAppointmentCancellationTaskMapper implements TaskMapper<TaskType.ManualAppointmentCancellation> {
  readonly type = TaskType.ManualAppointmentCancellation;

  map(r: TaskResponse): TaskDataMap[TaskType.ManualAppointmentCancellation] {
    return {
      memberId: r.data?.['memberId'] ?? '',
      memberName: r.data?.['memberName'] ?? '',
      memberPhoneNumber: normalizePhone(r.data?.['memberPhoneNumber']),
      partnerId: r.data?.['partnerId'] ?? '',
      partnerName: r.data?.['partnerName'] ?? '',
      partnerPhoneNumbers: r.data?.['partnerPhoneNumbers'] ?? <string[]>[],
      locationId: r.data?.['locationId'] ?? '',
      locationName: r.data?.['locationName'] ?? '',
      locationAddress: r.data?.['locationAddress'] ?? '',
      doctorName: r.data?.['doctorName'] ?? '',
      doctorId: r.data?.['doctorId'] ?? '',
      appointmentId: r.data?.['appointmentId'] ?? '',
      appointmentStartDate: r.data?.['appointmentStartDate'] ? new Date(r.data['appointmentStartDate']) : null,
      serviceName: r.data?.['serviceName'] ?? '',
      serviceCodes: r.data?.['serviceCodes'] ?? <string[]>[],
    };
  }
}
